<template>
  <v-card class="elevation-12">
    <v-expansion-panels v-model="panels" :multiple="true" focusable accordion>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <slot name="head-title"> Новая накладная</slot>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row v-if="showOrderActivePeriodDates || order.customerShipmentId">
            <template v-if="showOrderActivePeriodDates">
              <v-col cols="12" sm="6" lg="3" class="pa-2">
                <date-input v-model="order.date" :dense="true" label="Дата заказа" :hide-details="true" :outlined="true" :append-icon="false" :prepend-icon="false" :clearable="false" :disabled="true"/>
              </v-col>
              <v-col cols="12" sm="6" lg="2" class="pa-2">
                <date-input v-model="order.expiresOn" :dense="true" label="Конечный срок поставок" :hide-details="true" :outlined="true" :append-icon="false" :prepend-icon="false" :clearable="false" :disabled="true"/>
              </v-col>
            </template>

            <v-col cols="12" sm="6" lg="3" class="pa-2" :offset-lg="showOrderActivePeriodDates ? 2 : 0">
              <v-text-field v-model="order.number" :disabled="true" outlined dense :hide-details="true" label="Номер заказа"/>
            </v-col>
            <v-col cols="12" sm="6" lg="2" class="pa-2">
              <template v-if="order.customerShipmentId">
                <v-text-field v-model="order.customerShipmentId" :disabled="true" outlined dense :hide-details="true" label="ИД поставки в системе заказчика"/>
              </template>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" lg="3" class="pa-2">
              <v-text-field v-model="form.number" :dense="true" label="Номер накладной" :hide-details="true" :error="$v.form.number.$error || isNumberUniqueError" outlined :disabled="isConsignee"/>
            </v-col>
            <v-col cols="12" sm="6" lg="2" class="pa-2">
              <date-input v-model="form.date" :dense="true" label="Дата накладной" :hide-details="true" :error="$v.form.date.$error" :min="dateRange.min" :max="dateRange.max" :outlined="true" :append-icon="true"
                          :prepend-icon="false" :disabled="isConsignee"/>
            </v-col>
          </v-row>
          <v-row v-if="contractEditable">
            <v-col class="pa-2" md="7" lg="5">
              <SelectContract v-model="contract" :dense="true" :buyer-inn="order.customerInn" :default-value="defaultContract" :outlined="true" :disabled="isConsignee"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pa-2" cols="12" sm="6" lg="3">
              <v-text-field v-model="form.contractNumber" :disabled="true" :dense="true" outlined :hide-details="true" label="Номер договора" :error="$v.form.contractNumber.$error"/>
            </v-col>
            <v-col class="pa-2" cols="12" sm="6" lg="2">
              <date-input v-model="form.contractDate" :disabled="true" :append-icon="false" :prepend-icon="false" :dense="true" :clearable="false" outlined :hide-details="true" label="Дата договора"
                          :error="$v.form.contractDate.$error"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header> Данные доставки</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12">
              <h3>Данные транспорта</h3>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <v-combobox v-model="form.driverName" label="Водитель" dense :hide-details="true" class="py-2" :error="$v.form.driverName.$error" :items="carsAndDriversInfo.drivers" clearable outlined
                          :disabled="isConsignee">
                <template v-slot:item="{item}">
                  <span style="flex-grow: 1">
                    {{ item }}
                  </span>
                  <v-btn icon color="red" @click="()=>removeUnnecessaryDriverName(item)">
                    <v-icon size="18" right>fa-trash</v-icon>
                  </v-btn>
                </template>
              </v-combobox>

            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <v-combobox v-model="form.carSerial" label="Гос.номер машины" dense :hide-details="true" class="py-2" :error="$v.form.carSerial.$error" :items="carsAndDriversInfo.carSerials" clearable outlined
                          :disabled="isConsignee">
                <template v-slot:item="{item}">
                  <span style="flex-grow: 1">{{ item }}</span>
                  <v-btn icon color="red" @click="()=>removeUnnecessaryCarSerial(item)">
                    <v-icon size="18" right>fa-trash</v-icon>
                  </v-btn>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <v-combobox v-model="form.carModel" label="Модель машины" dense :hide-details="true" class="py-2" :error="$v.form.carModel.$error" :items="carsAndDriversInfo.cars" clearable outlined
                          :disabled="isConsignee">
                <template v-slot:item="{item}">
                  <span style="flex-grow: 1">{{ item }}</span>
                  <v-btn icon color="red" @click="()=>removeUnnecessaryCar(item)">
                    <v-icon size="18" right>fa-trash</v-icon>
                  </v-btn>
                </template>
              </v-combobox>
            </v-col>
          </v-row>

          <v-divider/>

          <v-row>
            <v-col lg="6" cols="12">
              <h3>Заказчик</h3>
              <b>Наименование</b>: {{ order.customerName }}
              <br/>
              <b>Инн</b>: {{ order.customerInn }}
              <br/>
              <b>Пункт отгрузки</b>: {{ order.deliveryAddress }}
            </v-col>
            <v-col lg="6" cols="12">
              <h3>Поставщик</h3>
              <b>Наименование</b>: {{ order.executorName }}
              <br/>
              <b>Инн</b>: {{ order.executorInn }}
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header> Сведегия о грузе</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
              :items="form.items"
              :fixed-header="true"
              :dense="true"
              :items-per-page="-1"
              :hide-default-footer="true"
              :headers="headers"
              :hide-default-header="$vuetify.breakpoint.xsOnly"
              :custom-filter="itemFilter"
              :search="search"
          >
            <template v-slot:top>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <v-text-field v-model="search" placeholder="Поиск" :dense="true" :hide-details="true" outlined/>
                </v-col>
                <v-spacer/>

                <v-col class="text-right" sm="6" md="8" lg="10">
                  <v-btn color="primary" small @click="onRestoreQuantitiesButtonClicked()"> Восстановить все количества</v-btn>
                  <v-btn color="primary" small @click="onClearQuantitiesButtonClicked()" class="ml-1"> Обнулить все количества</v-btn>
                </v-col>
              </v-row>
            </template>

            <template v-slot:item="{item, headers, index}">
              <tr>
                <template v-for="header in headers">
                  <td v-if="header.value === 'index'" class="text-left pa-0 px-1">{{ index + 1 }}</td>
                  <td v-if="header.value === 'product'" class="text-left pa-0 px-1" :class="$v.form.items.$each[index].product.$error ? 'error--text' : ''">
                    {{ item.product }}
                  </td>

                  <td v-if="header.value === 'customerSystemId'" class="text-right pa-0" style="width: 140px">
                    <v-text-field v-model="item.customerSystemId" dense outlined :hide-details="true" :disabled="true"/>
                  </td>
                  <td v-if="header.value === 'customerShipmentItemId'" class="text-right pa-0" style="width: 140px">
                    <v-text-field v-model="item.customerShipmentItemId" dense outlined :hide-details="true" :disabled="true"/>
                  </td>

                  <td v-if="header.value === 'customerCode'" class="text-right pa-0" style="width: 140px">
                    <v-text-field v-model="item.customerCode" :disabled="true" dense outlined :hide-details="true"/>
                  </td>
                  <td v-if="header.value === 'catalogCode'" class="text-right pa-0 px-1" style="width: 100px">
                    <SelectCatalogCodeDialog v-model="item.catalogCode" :default-value="item.catalogCode" :full-height="true"/>
                  </td>
                  <td v-if="header.value === 'measurement'" class="text-right pa-0 px-1">{{ item.measurement }}</td>
                  <td v-if="header.value === 'quantity'" class="text-right pa-0 px-1" :style="{width: '100px'}">
                    <v-text-field type="number" v-model="item.quantity"
                                  :dense="true"
                                  :hide-details="true"
                                  outlined
                                  class="right-input"
                                  :ref="`item-${index}`"
                                  @keydown.tab.exact.prevent="() => {}"
                                  @keydown.tab.shift.exact.prevent="() => {}"
                                  @keypress.tab.exact.prevent="() => {}"
                                  @keypress.tab.shift.exact.prevent="() => {}"
                                  @keyup.tab.exact.prevent="onItemTabKeyUp(index)"
                                  @keyup.tab.shift.exact.prevent="onItemShiftTabKeyUp(index)"
                                  :background-color="$v.form.items.$each[index].quantity.$error
                                    ? 'error lighten-1'
                                    : item.quantity == 0
                                      ? 'blue-grey darken-1'
                                      : 'success lighten-1'"
                                  @blur="$v.form.items.$each[index].quantity.$touch()"
                                  dark
                                  :error-messages="itemQuantityErrors(getItemIndex(item))"
                    />
                  </td>
                  <td v-if="header.value === 'price'" class="text-right pa-0 px-1">{{ item.price | decimalNoTrim }}</td>
                  <td v-if="header.value === 'total'" class="text-right pa-0 px-1">
                    {{ getItemTotal(item) | decimalMinorCeilTwoDigit }}
                  </td>
                  <td v-if="header.value === 'ndsRate'" class="text-center pa-0 px-1">{{ item.ndsRate }}</td>
                  <td v-if="header.value === 'ndsValue'" class="text-right pa-0 px-1">
                    {{ getItemNdsValue(item) | decimalMinorCeilTwoDigit }}
                  </td>
                  <td v-if="header.value === 'totalWithNds'" class="text-right pa-0 px-1">
                    {{ getItemTotalWithNds(item) | decimalMinorCeilTwoDigit }}
                  </td>
                </template>
              </tr>
            </template>

            <template v-slot:body.append="{headers}">
              <tr>
                <td :colspan="headers.length" class="text-right bold font-weight-bold pa-0 px-1">
                  {{ totalWithNds | decimalMinorCeilTwoDigit }} сум
                </td>
              </tr>
              <tr>
                <td :colspan="headers.length" class="text-right bold pa-0 px-1">
                  {{ totalWithNdsInWords }}
                </td>
              </tr>
            </template>

            <template v-slot:no-data>Нет таких данных</template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card-actions>
      <v-spacer/>
      <span v-if="$v.form.$error" class="mr-3 error--text">
        Пожалуйста проверьте и заполните форму полностью
      </span>

      <slot name="action-buttons">
        <v-btn @click="onCreateButtonCLicked" :color="$v.form.$error ? 'error' : 'primary'" ref="create-button">
          <slot name="button">
            Создать
          </slot>
        </v-btn>
      </slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import SelectCatalogCodeDialog from "@/components/Select/SelectCatalogCodeDialog";
import DateInput from "@/components/Input/DateInput";
import SelectContract from "@/components/Select/SelectContract";
import {validationMixin} from "vuelidate";
import _ from "underscore";
import ItemCalculator from "@/helpers/item.calculator";
import AmountTextHelper from "@/helpers/amount.text";
import {decimal, maxLength, required} from "vuelidate/lib/validators";
import * as OrderItemQuantityLimitStrategies from "@/enum/OrderItemQuantityLimitStrategyType";
import ProductService from "@/services/product.service";
import {DefineByExecutor} from "@/enum/OrderProductNameDefineMethodStrategyType";
import {DefineInOrder} from "@/enum/OrderContractDefineMethodStrategyType";
import Moment from "moment";
import ContractService from "@/services/contract.service";
import {FromOrderExpireDate} from "@/enum/OrderShipmentDeliveryDateStrategyType";
import {FromOrderDateToOrderExpires} from "@/enum/OrderShipmentDateMethodStrategyType";
import {MOMENT_API_DATE_FORMAT, MOMENT_API_DATETIME_FORMAT} from "@/settings";

const carsAndDriversInfoKey = 'carsAndDrivers'

export default {
  name: "ReturnShipmentForm",
  components: {SelectCatalogCodeDialog, DateInput, SelectContract},
  mixins: [validationMixin],
  props: {
    order: {
      type: Object,
      default: () => {
        return null
      }
    },
    shipment: {
      type: Object,
      default: () => {
        return null
      }
    },
    isConsignee: {
      type: Boolean,
      default: false
    },
    isNumberUniqueError: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dateEditable: false,
      contractEditable: false,
      showOrderActivePeriodDates: false,
      defaultContract: null,

      dateRange: {
        min: null,
        max: null
      },
      form: {
        number: '',
        date: null,
        contractNumber: '',
        contractDate: null,

        driverName: '',
        carSerial: '',
        carModel: '',

        items: []
      },

      carsAndDriversInfo: localStorage.getItem(carsAndDriversInfoKey)
          ? JSON.parse(localStorage.getItem(carsAndDriversInfoKey))
          : {
            drivers: [],
            cars: [],
            carSerials: []
          },

      panels: [0, 1, 2],
      contract: null,
      specifications: [],
      search: '',
    }
  },
  computed: {
    headers() {
      const headers = []

      headers.push({
        text: '#',
        value: 'index',
        sortable: false,
        width: '20',
        class: 'pa-0 font-weight-bold',
        align: 'left'
      });
      headers.push({text: 'Товар', value: 'product', sortable: true, class: 'pa-0 font-weight-bold', align: 'left'})

      /*headers.push({text: "ИД позиции заказа", value: "customerSystemId", sortable: true, class: "pa-0", align: "left"})*/
      if (_.filter(this.form.items, item => {
        return !!item.customerShipmentItemId
      }).length > 0)
        headers.push({text: "ИД позиции поставки", value: "customerShipmentItemId", sortable: true, class: "pa-0", align: "left"})

      if (_.filter(this.form.items, item => {
        return !!item.customerCode
      }).length > 0)
        headers.push({text: "Штрих-код", value: "customerCode", sortable: true, class: "pa-0", align: "left"})

      if (_.filter(this.form.items, item => {
        return !!item.catalogCode
      }).length > 0)
        headers.push({text: "ИКПУ код", value: "catalogCode", sortable: true, class: "pa-0", align: "right"})

      headers.push({
        text: 'Ед. изм.',
        value: 'measurement',
        sortable: false,
        width: 100,
        class: 'pa-0 font-weight-bold',
        align: 'right'
      })
      headers.push({
        text: 'Количество',
        value: 'quantity',
        sortable: false,
        class: 'pa-0 font-weight-bold',
        align: 'right'
      })
      headers.push({
        text: 'Цена',
        value: 'price',
        sortable: false,
        width: 100,
        class: 'pa-0 font-weight-bold',
        align: 'right'
      })
      headers.push({
        text: 'Стоимость',
        value: 'total',
        sortable: false,
        width: 100,
        class: 'pa-0 font-weight-bold',
        align: 'right'
      })
      headers.push({
        text: 'Ставка НДС в %',
        value: 'ndsRate',
        sortable: false,
        width: 70,
        class: 'pa-0 font-weight-bold',
        align: 'right'
      })
      headers.push({
        text: 'Сумма НДС',
        value: 'ndsValue',
        sortable: false,
        width: 100,
        class: 'pa-0 font-weight-bold',
        align: 'right'
      })
      headers.push({
        text: 'Итого',
        value: 'totalWithNds',
        sortable: false,
        width: 140,
        class: 'pa-0 font-weight-bold',
        align: 'right'
      })
      return headers
    },
    totalWithNds() {
      let totalsWithNds = _.map(this.form.items, item => {
        return this.getItemTotalWithNds(item)
      })

      return ItemCalculator.getSumTotalWithNds(totalsWithNds)
    },
    totalWithNdsInWords() {
      return AmountTextHelper.getText(this.totalWithNds)
    },
  },
  validations: {
    form: {
      number: {
        required,
        maxLength: maxLength(100),
      },
      date: {
        required,
      },
      contractNumber: {
        required,
        maxLength: maxLength(100)
      },
      contractDate: {
        required
      },
      driverName: {
        required,
        maxLength: maxLength(100)
      },
      carSerial: {
        required,
        maxLength: maxLength(50)
      },
      carModel: {
        required,
        maxLength: maxLength(100)
      },
      items: {
        $each: {
          product: {
            required,
            maxLength: maxLength(200),
          },
          quantity: {
            required,
            decimal,
            strategy(value, item) {
              const quantity = +item.quantity
              let itemIndex = -1;
              _.each(this.form.items, (formItem, index) => {
                if (formItem === item)
                  itemIndex = index;
              });

              if (itemIndex > -1 && itemIndex < this.order.items.length) {
                if (this.order.itemQuantityLimitStrategy === OrderItemQuantityLimitStrategies.SumLimit) {
                  if (this.shipment) {
                    const shipmentItem = this.shipment.items.find(shipmentItem => {
                      return shipmentItem.id === item.id
                    })
                    return 0 <= quantity && quantity <= this.order.items[itemIndex].quantityLeft + shipmentItem.quantity
                  }
                }

                return 0 <= quantity && quantity <= this.order.items[itemIndex].quantityLeft
              }

              return false
            }
          }
        }
      }
    },
  },
  methods: {
    // methods
    removeUnnecessaryDriverName(item) {
      const driverName = this.carsAndDriversInfo.drivers.find(el => {
        return el === item
      });
      this.carsAndDriversInfo.drivers.splice(driverName, 1)
    },
    removeUnnecessaryCarSerial(item) {
      const carSerial = this.carsAndDriversInfo.carSerials.find(el => {
        return el === item
      });
      this.carsAndDriversInfo.carSerials.splice(carSerial, 1)
    },
    removeUnnecessaryCar(item) {
      const car = this.carsAndDriversInfo.cars.find(el => {
        return el === item
      });
      this.carsAndDriversInfo.cars.splice(car, 1)
    },

    loadSpecifications() {
      ProductService.getSpecifications({})
          .then(response => {
            this.specifications = _.map(response.data.Records, ps => {
              return {
                id: ps.Id,
                contractorInn: ps.ContractorInn,
                ownerProduct: ps.OwnerProduct,
                contractorProduct: ps.ContractorProduct
              }
            });

            this.onEventSpecificationsLoaded()
          })
    },

    syncItems() {
      if (this.shipment) {
        this.form.items = this.shipment.items.map(item => {
          const orderItem = this.order.items.find(orderItem => {
            return orderItem.id === item.orderItem.id
          })

          return {
            order: {
              itemId: orderItem.id,
              product: orderItem.product,
              quantity: orderItem.quantity,
              quantityLeft: orderItem.quantityLeft,
            },

            id: item.id,
            quantity: Math.abs(item.quantity),
            product: item.product,
            measurement: item.measurement,
            ndsRate: item.ndsRate,
            price: item.price,
            customerCode: item.customerCode,
            catalogCode: item.catalogCode,
            customerShipmentItemId: orderItem.customerShipmentItemId,
            customerSystemId: orderItem.customerSystemId
          }
        })
      } else {
        this.form.items = _.map(this.order.items, item => {
          return {
            id: null,
            order: {
              itemId: item.id,
              product: item.product,
              quantity: item.quantity,
              quantityLeft: item.quantityLeft,
            },

            product: item.product,
            measurement: item.measurement,
            ndsRate: item.ndsRate,
            price: item.price,
            quantity: item.quantityLeft,
            customerCode: item.customerCode,
            catalogCode: item.catalogCode,
            customerShipmentItemId: item.customerShipmentItemId,
            customerSystemId: item.customerSystemId
          };
        })
      }

      if (this.order.productNameDefineMethodStrategy === DefineByExecutor) {
        for (let i = 0; i < this.form.items.length; i++) {
          let specs = _.filter(this.specifications, ps => {
            return ps.contractorProduct !== ps.ownerProduct && ps.contractorProduct === this.form.items[i].order.product;
          });

          if (specs.length === 1)
            this.form.items[i].product = specs[0].ownerProduct;
        }
      }
    },

    // events
    onEventContractChanged() {
      if (this.contract) {
        this.form.contractNumber = this.contract.number
        this.form.contractDate = this.contract.date
      } else {
        this.form.contractNumber = ''
        this.form.contractDate = null
      }
    },
    onEventSpecificationsLoaded() {
      this.syncItems()
    },

    // UI
    onClearQuantitiesButtonClicked() {
      _.each(this.form.items, item => {
        item.quantity = 0
      })
    },
    onRestoreQuantitiesButtonClicked() {
      if (this.shipment) {
        _.each(this.form.items, item => {
          const shipmentItem = this.shipment.items.find(shipmentItem => {
            return shipmentItem.id === item.id
          })
          item.quantity = shipmentItem.quantity
        })
      } else {
        _.each(this.form.items, item => {
          item.quantity = item.order.quantityLeft
        })
      }
    },
    onCreateButtonCLicked() {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        let data = {
          ReturnOrderId: this.order.id,
          IsTrailer: false,
          IsSemiTrailer: false,
          TrailerSerialNumber: null,
          TrailerModel: null,
          Number: this.form.number,
          Date: this.form.date.format(MOMENT_API_DATE_FORMAT),
          ContractNumber: this.form.contractNumber,
          ContractDate: this.form.contractDate.format(MOMENT_API_DATE_FORMAT),

          DriverName: this.form.driverName,
          CarSerialNumber: this.form.carSerial,
          CarModel: this.form.carModel,

          CustomerInn: this.order.executorInn,
          CustomerName: this.order.executorName,
          ConsigneeInn: this.order.customerInn,
          ConsigneeName: this.order.customerName,

          DeliveryAddress: this.order.deliveryAddress,
          LoadingAddress: 'Склад',

          DeliveryDateTime: this.order.expiresOn.format(MOMENT_API_DATETIME_FORMAT),
          items: _.map(this.form.items, item => {
            return {
              id: item.id,
              ReturnOrderItemId: item.order.itemId,
              Product: item.product,
              CustomerCode: item.customerCode,
              Measurement: item.measurement,
              Quantity: +item.quantity,
              Price: item.price,
              NdsRate: item.ndsRate,
              CatalogCode: item.catalogCode ? item.catalogCode.classCode : null,
              CatalogName: item.catalogCode ? item.catalogCode.classNameRu : null,
            }
          })
        }
        if (!this.contract && this.contractEditable) {
          ContractService.addSellerContract({
            seller: this.$store.getters.companyInn,
            buyer: this.order.customerInn,
            number: this.form.contractNumber,
            date: this.form.contractDate,
            isPrimary: true
          })
              .finally(() => {
                this.saveCarAndDriversInfo()
                this.$emit("save", data)
              })
        } else {
          this.saveCarAndDriversInfo()
          this.$emit('save', data)
        }
      }
    },
    onItemTabKeyUp(index) {
      const ref = this.$refs[`item-${index + 1}`]
      if (ref && ref.length > 0)
        ref[0].focus()
    },
    onItemShiftTabKeyUp(index) {
      const ref = this.$refs[`item-${index - 1}`]
      if (ref && ref.length > 0)
        ref[0].focus()
    },


    // helpers
    itemFilter(value, search, item) {
      let pieces = _.filter(search.split(' '), p => {
        return p.length > 0;
      });
      return _.every(pieces, p => {
        return item.product.toString().toLocaleUpperCase().indexOf(p.toLocaleUpperCase()) !== -1;
      });
    },
    getItemTotal(item) {
      return ItemCalculator.getTotal(item.quantity, item.price)
    },
    getItemNdsValue(item) {
      return ItemCalculator.getNdsValue(item.quantity, item.price, item.ndsRate)
    },
    getItemTotalWithNds(item) {
      return ItemCalculator.getTotalWithNds(item.quantity, item.price, item.ndsRate)
    },
    saveCarAndDriversInfo() {
      if (this.carsAndDriversInfo.drivers.indexOf(this.form.driverName) === -1)
        this.carsAndDriversInfo.drivers.push(this.form.driverName)

      if (this.carsAndDriversInfo.cars.indexOf(this.form.carModel) === -1)
        this.carsAndDriversInfo.cars.push(this.form.carModel)

      if (this.carsAndDriversInfo.carSerials.indexOf(this.form.carSerial) === -1)
        this.carsAndDriversInfo.carSerials.push(this.form.carSerial)

      localStorage.setItem(carsAndDriversInfoKey, JSON.stringify(this.carsAndDriversInfo))
    },
    getItemIndex(item) {
      return this.form.items.indexOf(item)
    },
    itemQuantityErrors(index) {
      const errors = [];
      if (this.$v.form.items.$each[index].quantity.$dirty) {
        !this.$v.form.items.$each[index].quantity.decimal && errors.push('Неверный формат числа');
        !this.$v.form.items.$each[index].quantity.strategy && errors.push('Недоступное значение');
      }
      return errors;
    },

    // new
    initializeFromOrder() {
      // contract strategy
      if (this.order.contractDefineMethodStrategy === DefineInOrder) {
        this.form.contractNumber = this.order.contractNumber
        this.form.contractDate = this.order.contractDate
        this.contractEditable = false;
      } else {
        this.contractEditable = true;
      }

      // shipment delivery date
      if (this.order.shipmentDeliveryDateStrategy === FromOrderExpireDate) {
        this.dateEditable = false
        this.form.date = this.order.expiresOn
      } else {
        this.dateEditable = true
      }

      if (this.order.shipmentDateMethodStrategy === FromOrderDateToOrderExpires) {
        this.showOrderActivePeriodDates = true
        this.dateRange.min = this.order.date
        this.dateRange.max = this.order.expiresOn

        // set today as min value if order.date < today
        const today = Moment()
        if (today.isAfter(this.order.date, 'date'))
          this.dateRange.min = today
      } else {
        this.showOrderActivePeriodDates = false
        this.dateRange.min = null
        this.dateRange.max = null
      }
    },
    setFormFromOrder() {
      this.form.date = Moment()
      this.syncItems()

      if (this.order.productNameDefineMethodStrategy === DefineByExecutor) {
        this.loadSpecifications()
      }

      if (this.order.shipmentDeliveryDateStrategy === FromOrderExpireDate)
        this.form.date = this.order.date
    },
    setFormFromShipment() {
      this.form.date = this.shipment.date
      this.form.number = this.shipment.number
      this.form.contractNumber = this.shipment.contractNumber
      this.form.contractDate = this.shipment.contractDate
      this.form.driverName = this.shipment.driverName
      this.form.carSerial = this.shipment.carSerial
      this.form.carModel = this.shipment.carModel
      this.syncItems()
    }
  },
  created() {
    this.initializeFromOrder()

    if (this.shipment) {
      this.setFormFromShipment()
    } else {
      this.setFormFromOrder()
    }
  },
  watch: {
    contract() {
      this.onEventContractChanged()
    }
  }
}
</script>

<style>
.right-input input {
  text-align: right !important;
}
</style>